import { render } from "./PageModal.vue?vue&type=template&id=76cf47c6"
import script from "./PageModal.vue?vue&type=script&lang=js"
export * from "./PageModal.vue?vue&type=script&lang=js"

import "./PageModal.vue?vue&type=style&index=0&id=76cf47c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__